var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesert2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7C21.6569 7 23 5.65685 23 4C23 2.34315 21.6569 1 20 1C18.3431 1 17 2.34315 17 4C17 5.65685 18.3431 7 20 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C6.89543 5 6 5.89543 6 7V11H5C4.44772 11 4 10.5523 4 10V8.5C4 7.67157 3.32843 7 2.5 7C1.67157 7 1 7.67157 1 8.5V10C1 12.2091 2.79086 14 5 14H6V18.2355C5.0228 18.0805 4.0208 18 3 18L2.94904 18.0001C2.41688 18.0015 2 18.4432 2 18.9754V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V17.2141C22 16.6206 21.4855 16.1556 20.8999 16.2517C17.791 16.7619 14.9361 18.0266 12.5296 19.8518C12.2072 20.0962 11.7731 20.1374 11.4105 19.9581C10.9505 19.7307 10.4801 19.5214 10 19.331V17H11C13.2091 17 15 15.2091 15 13V11.5C15 10.6716 14.3284 10 13.5 10C12.6716 10 12 10.6716 12 11.5V13C12 13.5523 11.5523 14 11 14H10V7C10 5.89543 9.10457 5 8 5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.25C20.4142 8.25 20.75 8.58579 20.75 9V11C20.75 11.4142 20.4142 11.75 20 11.75C19.5858 11.75 19.25 11.4142 19.25 11V9C19.25 8.58579 19.5858 8.25 20 8.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9947 8.06597C17.2876 7.77308 17.2876 7.29821 16.9947 7.00531C16.7018 6.71242 16.2269 6.71242 15.934 7.00531L14.5198 8.41953C14.2269 8.71242 14.2269 9.18729 14.5198 9.48019C14.8127 9.77308 15.2876 9.77308 15.5805 9.48019L16.9947 8.06597Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H13C12.5858 4.75 12.25 4.41421 12.25 4C12.25 3.58579 12.5858 3.25 13 3.25H15C15.4142 3.25 15.75 3.58579 15.75 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert2);
export default __webpack_public_path__ + "static/media/desert-2.b705a02ffa3952de5da4a62dba4c7ea7.svg";
export { ForwardRef as ReactComponent };